import view from './view';
import icon from '@plone/volto/icons/clock.svg';

export default {
  id: 'hp_latest_published',
  title: 'HP Latest Published',
  icon: icon,
  group: 'homepage',
  view: view,
};
